import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- Performance: resource hints + hero preload (above-the-fold priority) ---
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/rnC4SmbU4HFAq3PV1KVyJf/ChatGPT_Image_21_may_2026_06_31_23.webp';
function addHead(tag: string, attrs: Record<string, string>) {
  const el = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
}
// Preconnect / dns-prefetch to the asset & font origins so the first paint is fast
;
['https://cdn.magicpatterns.com', 'https://cdn.shopify.com', 'https://images.unsplash.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'].forEach(href => {
  addHead('link', {
    rel: 'preconnect',
    href,
    crossorigin: ''
  });
  addHead('link', {
    rel: 'dns-prefetch',
    href
  });
});
// Preload ONLY the main hero image with high priority for a fast LCP
addHead('link', {
  rel: 'preload',
  as: 'image',
  href: HERO_IMAGE,
  fetchpriority: 'high'
});
render(<App data-id="element-222" />, document.getElementById('root'));